const SET_DEPARTMENT_DETAILS = (state, payload) => {
  state.selectedDepartment = payload.department;
  state.selectedDepartment.latestItems = payload.latestContent
    ? payload.latestContent.results.map((hit) => hit.item)
    : [];
};

export default SET_DEPARTMENT_DETAILS;
